import styled, { css } from "styled-components";
import {theme} from "../../styles/theme";

const getShouldForwardProps = (...args) => {
	const props = args.flat(2)

	return { shouldForwardProp: (propName) => !props.includes(propName) }
}

export const DropdownStyled = styled.div`
    position: relative;
`;

export const DropdownToggleStyled = styled.div`
    gap: 16px;
    display: flex;
    cursor: pointer;
    border-radius: 6px;
    align-items: center;
    padding: 10px 16px;
    background-color: ${theme.colors.black_4};

    &:hover {
        color: ${theme.colors.black_48};
        background-color: ${theme.colors.black_2};
    }
`;

export const DropdownMenuStyled = styled.div`
    position: absolute;
    left: 50%;
    top: calc(100% + 8px);
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 8px;
    border-radius: 6px;
    background-color: #fff;
    box-shadow: 0px 8px 16px 0px ${theme.colors.black_8};
`;

export const DropdownMenuItemStyled = styled.div.withConfig(getShouldForwardProps('active'))`
    gap: 16px;
    display: flex;
    cursor: pointer;
    border-radius: 6px;
    align-items: center;
    padding: 10px 10px;
    min-width: 73px;
    background-color: #fff;

    ${({ active }) => active && css`
        color: ${theme.colors.black_48};
        background-color: ${theme.colors.black_4};
    `}
    
    &:hover {
        color: ${theme.colors.black_48};
        background-color: ${theme.colors.black_4};
    }
`;
